import { Container, Text } from 'pixi.js';

interface FloatItem { text: Text; vy: number; life: number; max: number; spawnT: number; }

export class FloatTextSystem {
  private items: FloatItem[] = [];
  private layer: Container;

  constructor(stage: Container) {
    this.layer = new Container();
    stage.addChild(this.layer);
  }

  spawn(msg: string, x: number, y: number, color = 0xffffff, size = 16): void {
    const t = new Text({
      text: msg,
      style: {
        fontFamily: 'Courier New', fontSize: size, fill: color, fontWeight: 'bold',
        dropShadow: { color: 0x000000, alpha: 0.85, distance: 2, angle: Math.PI / 4, blur: 3 },
      },
    });
    t.anchor.set(0.5, 1);
    t.x = x; t.y = y;
    t.scale.set(0.4, 0.4);
    this.layer.addChild(t);
    this.items.push({ text: t, vy: -50, life: 1.0, max: 1.0, spawnT: 0 });
  }

  update(dt: number): void {
    for (let i = this.items.length - 1; i >= 0; i--) {
      const it = this.items[i];
      it.life -= dt;
      it.spawnT += dt;
      it.text.y += it.vy * dt;
      it.vy *= Math.pow(0.9, dt * 60);
      // Squash-spawn: 0→1.4 over 0.10s, 1.4→1.0 over 0.10s, then steady
      const s = it.spawnT;
      let scale: number;
      if (s < 0.10) scale = 0.4 + (1.4 - 0.4) * (s / 0.10);
      else if (s < 0.20) scale = 1.4 - (1.4 - 1.0) * ((s - 0.10) / 0.10);
      else scale = 1.0;
      it.text.scale.set(scale, scale);
      it.text.alpha = Math.max(0, it.life / it.max);
      if (it.life <= 0) {
        it.text.parent?.removeChild(it.text);
        it.text.destroy();
        this.items.splice(i, 1);
      }
    }
  }
}
